<template>
    <a
        :href="url"
        target="_blank"
        rel="noopener noreferrer"
        class="pcontact"
        :aria-label="$t('property-contact.aria')"
    >
        <span class="pcontact__icon" aria-hidden="true">
            <i class="fab fa-whatsapp"></i>
        </span>
        <span class="pcontact__text">
            <small>{{ $t('property-contact.help') }}</small>
            <strong>{{ $t('property-contact.button') }}</strong>
        </span>
        <i class="fas fa-arrow-right pcontact__arrow" aria-hidden="true"></i>
    </a>
</template>

<script>
import { propertyContact } from '@/config';

/**
 * Botón de contacto / ayuda para el usuario property. Abre WhatsApp con el
 * número de soporte de property y un mensaje ya escrito que dice quién es, para
 * que del otro lado no tengan que preguntarle.
 */
export default {
    name: 'PropertyContactButton',
    computed: {
        url() {
            const user = this.$store.state.user || {};
            const nombre = `${user.nombre || ''} ${user.apellido || ''}`.trim();
            const mensaje = nombre
                ? this.$t('property-contact.message-named', { nombre })
                : this.$t('property-contact.message');

            return `https://wa.me/${propertyContact.phone}?text=${encodeURIComponent(mensaje)}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.pcontact {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 10px 16px 10px 10px;

    /* Celular: ocupa todo el ancho del encabezado y la flecha va al extremo. */
    @media (max-width: 600px) {
        display: flex;
        width: 100%;

        .pcontact__arrow { margin-left: auto; }
    }
    border: 1px solid #eceae4;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(8px);
    color: #0a0a0b;
    text-decoration: none;
    box-shadow: 0 1px 2px rgba(10, 10, 11, 0.04), 0 8px 24px rgba(10, 10, 11, 0.06);
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

    &:hover {
        border-color: #25d366;
        color: #0a0a0b;
        text-decoration: none;
        transform: translateY(-2px);
        box-shadow: 0 12px 28px rgba(37, 211, 102, 0.18);

        .pcontact__arrow { transform: translateX(3px); color: #1ebe5a; }
    }

    &:focus-visible {
        outline: 2px solid #0a0a0b;
        outline-offset: 2px;
    }

    &__icon {
        flex: 0 0 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 11px;
        background: linear-gradient(135deg, #2ee37a 0%, #1ebe5a 100%);
        color: #fff;
        font-size: 22px;
        box-shadow: 0 4px 12px rgba(37, 211, 102, 0.35);
    }

    &__text {
        display: flex;
        flex-direction: column;
        min-width: 0;
        line-height: 1.2;

        small {
            font-size: 11px;
            color: #6e6e76;
        }

        strong {
            font-size: 14px;
            font-weight: 600;
            overflow-wrap: anywhere;
        }
    }

    &__arrow {
        margin-left: 4px;
        font-size: 12px;
        color: #a0a0a8;
        transition: transform 0.2s ease, color 0.2s ease;
    }
}
</style>
